import { render, staticRenderFns } from "./webinares.vue?vue&type=template&id=113b8ab5&scoped=true"
import script from "./webinares.vue?vue&type=script&lang=js"
export * from "./webinares.vue?vue&type=script&lang=js"
import style0 from "./webinares.vue?vue&type=style&index=0&id=113b8ab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b8ab5",
  null
  
)

export default component.exports